import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams} from "react-router-dom";
import Header from '../components/Header';
import { LevelRow } from './components';
import levelJson from '../../../assets/json/clubRating';
import {useSelector} from "react-redux";
import {getCurrentClub} from "../../../store/selectors";

const ClubBuyLevel = () => {
  const { t } = useTranslation();
  const {id} = useParams();
  const clubData = useSelector(getCurrentClub);

  return (
      <React.Fragment>
        <Header title={`clubRatings`} to={`/club/${id}/settings`}/>
        <div className="clubRatings clubPage">
          <div className="currentLevelRow">
            <div className="firstColumn">
              <span className="myLvl">{t('lvl')} {clubData.level}</span>
              <ul>
                {
                  [...Array(10)].map((e, index) =>
                      <span key={index} className={index < clubData.level ? 'activeStar' : 'inActiveStar'}></span>
                  )
                }
              </ul>
            </div>
            <div className="secondColumn">
              <span>200</span>
            </div>

          </div>
          { levelJson.map( club => <LevelRow key={club.level} club={club} isActive={(clubData.level || 0) <= club.level} /> ) }
        </div>
      </React.Fragment>
  );
};

export default ClubBuyLevel;
